export default __webpack_public_path__ + "static/media/parkingrampe5.72917d23.png";